
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5426_61)"}},[_c('path',{attrs:{"d":"M19.812 16.385L1.125 1.776a.5.5 0 00-.703.078l-.312.39a.5.5 0 00.078.704l18.687 14.608a.5.5 0 00.703-.077l.312-.39a.499.499 0 00-.078-.704zM9.275 6.244l4.212 3.293a3.49 3.49 0 00-4.212-3.293zm1.45 6.845L6.513 9.796a3.491 3.491 0 004.212 3.293zM10 5.167c3.083 0 5.909 1.718 7.435 4.5a8.921 8.921 0 01-1.375 1.88l1.18.922a10.425 10.425 0 001.652-2.347 1.01 1.01 0 000-.912C17.196 5.904 13.842 3.667 10 3.667c-1.147 0-2.24.218-3.27.587l1.45 1.134A8.202 8.202 0 0110 5.167zm0 9c-3.083 0-5.909-1.72-7.435-4.5A8.92 8.92 0 013.94 7.785l-1.179-.922A10.425 10.425 0 001.11 9.21a1.01 1.01 0 000 .913c1.695 3.306 5.05 5.543 8.891 5.543 1.147 0 2.24-.22 3.27-.588l-1.45-1.133a8.221 8.221 0 01-1.82.221z","fill":"#49454F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5426_61"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    